<template>
  <v-wait for="ariza-kayit-inserting">
    <template slot="waiting">
      <div class="vue-wait-class">
        <img src="static/loading.svg" />
        <p>Kayıt yapılıyor...</p>
      </div>
    </template>
    <div class="container">
      <div class="py-3 text-center">
        <h2>Arızalı Cihaz Kayıt Formu</h2>
        <p class="lead">Gelen ürüne ait bilgileri aşağıdaki forma işleyiniz.</p>
      </div>
      <div class="row">
        <div class="col-md-4 order-md-2 mb-4">
          <h4 class="d-flex justify-content-between align-items-center mb-3">
            <span class="text-muted">Kayıt Önizlemesi</span>
            <span class="badge badge-secondary badge-pill">{{gotPieceCount}}</span>
          </h4>
          <label class="transparent-label" for="">Boş Label</label>
          <ul class="list-group mb-3">
            <li class="list-group-item d-flex justify-content-between lh-condensed">
              <div>
                <h6 class="my-0">{{deviceId}}</h6>
                <label v-if="deviceId" class="switch text-right">
                  <input type="checkbox" v-model="deviceInWarrantyPeriod">
                  <span class="slider round"></span>
                </label>
                <small class="text-muted">{{deviceModel}}</small>
                <small v-if="deviceId" v-bind:class="{'text-success': deviceInWarrantyPeriod == 0, 'text-danger': deviceInWarrantyPeriod == 1}">
                  {{deviceInWarrantyPeriod == 0 ? "Ürün garantisi devam ediyor" : "Ürün garanti dışı"}}
                </small>
              </div>
            </li>
            <li v-for="equip in equipments" :key="equip.PieceId" class="list-group-item d-flex justify-content-between lh-condensed">
              <div>
                <h6 class="my-0">{{equip.PieceName}}</h6>
                <label class="switch text-right">
                  <input type="checkbox" v-model="equip.Status">
                  <span class="slider round"></span>
                </label>
                <small v-bind:class="{'text-success': equip.Status == 0, 'text-danger': equip.Status == 1}">{{equip.Status == 0 ? "Ekipman sağlıklı durumda" : "Ekipman arızalı"}}</small>
              </div>
            </li>
          </ul>
          <div class="mb-3"></div>
          <button class="btn btn-block btn-primary" @click="insertArizaKaydi">Kaydı Tamamla</button>
        </div>
        <div class="col-md-8 order-md-1">
          <h4 class="mb-3">Gelen Ürün Bilgileri</h4>
          <div class="row">
            <div class="col-md-6 mb-3">
              <label for="firstName">Geliş Tarihi</label>
              <datepicker :bootstrap-styling="true" v-model="arrivalDate" :format="dateFormatter"></datepicker>
              <!--<input type="text" class="form-control date-input" id="firstName" placeholder="" value="" required>-->
              <div class="invalid-feedback">
                Valid first name is required.
              </div>
            </div>
            <div class="col-md-6 mb-3">
              <label for="lastName">Cihaz Seri Numarası</label>
              <input type="text" class="form-control" :disabled="procStatus == 1" v-bind:class="{'loading' : procStatus == 1}" @keyup.enter="getDeviceInfo" v-model="deviceId" id="lastName" placeholder="" value="" maxlength="15" required>
              <div class="invalid-feedback">
                Valid last name is required.
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 mb-3">
              <label for="customerTitle">Müşteri Adı</label>
              <input type="text" class="form-control" disabled :value="customerTitle" id="customerTitle" placeholder="" required>
              <div class="invalid-feedback">
                Valid last name is required.
              </div>
            </div>
            <div class="col-md-6 mb-3">
              <label for="vehicleName">Araç Plakası</label>
              <input type="text" class="form-control" disabled id="vehicleName" placeholder="" :value="vehicleName" required>
              <div class="invalid-feedback">
                Valid last name is required.
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 mb-3">
              <label for="customer-address">Müşteri Adresi</label>
              <textarea class="form-control" disabled id="customer-address" rows="6"
                placeholder="" :value="customerAddress" required></textarea>
            </div>
            <div class="col-md-6 mb-3">
              <label for="sender-address">Gönderi Adresi</label>
              <textarea class="form-control" id="sender-address" rows="6"
                placeholder="" v-model="incomingAddress" required></textarea>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 mb-3">
              <label for="piecesLabel">NVR & DVR Ekipmanlari</label>
              <ul class="list-group">
                <li class="list-group-item" v-for="(piece, index) in pieces" :key="piece.PieceName" v-if="piece.Group == 1">
                  <div class="custom-control custom-checkbox mr-sm-2">
                    <input type="checkbox" class="custom-control-input" v-model="equipments" v-bind:value="piece" v-bind:id="index">
                    <label class="custom-control-label light-text" v-bind:for="index">{{piece.PieceName}}</label>
                  </div>
                </li>
              </ul>
            </div>
            <div class="col-md-4 mb-3">
              <label for="piecesLabel">Genel Ekipmanlar</label>
              <ul class="list-group">
                <li class="list-group-item" v-for="(piece, index) in pieces" :key="piece.PieceName" v-if="piece.Group == 2">
                  <div class="custom-control custom-checkbox mr-sm-2">
                    <input type="checkbox" class="custom-control-input" v-model="equipments" v-bind:value="piece" v-bind:id="index">
                    <label class="custom-control-label light-text" v-bind:for="index">{{piece.PieceName}}</label>
                  </div>
                </li>
              </ul>
            </div>
            <div class="col-md-4 mb-3">
              <label for="piecesLabel">Ek Ünite Ekipmanları</label>
              <ul class="list-group">
                <li class="list-group-item" v-for="(piece, index) in pieces" :key="piece.PieceName" v-if="piece.Group == 3">
                  <div class="custom-control custom-checkbox mr-sm-2">
                    <input type="checkbox" class="custom-control-input" v-model="equipments" v-bind:value="piece" v-bind:id="index">
                    <label class="custom-control-label light-text" v-bind:for="index">{{piece.PieceName}}</label>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="mb-3">
            <label for="sender-name">Gönderici Adı</label>
            <input type="text" class="form-control" id="sender-name" v-model="senderName" placeholder="">
          </div>
          <div class="mb-3">
            <label for="incoming-document-code">Gelen İrsaliye Numarası</label>
            <input type="text" class="form-control" id="incoming-document-code" v-model="arrivalDocumentCode" placeholder="">
          </div>
          <div class="mb-3">
            <label for="ariza-note">Bilgi Notları</label>
            <textarea class="form-control" id="ariza-note" rows="5" placeholder="" v-model="arizaNote" required></textarea>
          </div>
          <button class="btn btn-primary btn-lg btn-block" @click="insertArizaKaydi">Kaydı Tamamla</button>
        </div>
      </div>
      <div class="mb-4"></div>
    </div>
  </v-wait>
</template>

<script>
/* eslint-disable */

import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import axios from 'axios'

export default {
  name: 'ArizaKayitPage',
  components: {
    'datepicker': Datepicker
  },
  data () {
    return {
      procStatus: 0,
      deviceId: '',
      deviceModel: '',
      deviceInWarrantyPeriod: false,
      equipments: [],
      customerTitle: '',
      customerAddress: '',
      deviceModel: '',
      vehicleName: '',
      arrivalDocumentCode: '',
      senderName: '',
      incomingAddress: '',
      arrivalDate: '',
      arizaNote: '',
      pieces: [
        {"PieceName": "GSM Anteni", "PieceId": 1, "Status": 0, "Group": 2},
        {"PieceName": "GPS Anteni", "PieceId": 2, "Status": 0, "Group": 2},
        {"PieceName": "Power Kablosu", "PieceId": 3, "Status": 0, "Group": 2},
        {"PieceName": "SIM Kart", "PieceId": 4, "Status": 0, "Group": 2},
        {"PieceName": "Röle", "PieceId": 5, "Status": 0, "Group": 2},
        {"PieceName": "Röle Soketi", "PieceId": 6, "Status": 0, "Group": 2},
        {"PieceName": "Bloke Kablo", "PieceId": 7, "Status": 0, "Group": 2},
        {"PieceName": "İkili Max Ara Kablo", "PieceId": 8, "Status": 0, "Group": 2},
        {"PieceName": "LNX-66 IP Kamera", "PieceId": 9, "Status": 0, "Group": 1},
        {"PieceName": "LNC-104 IP Kamera", "PieceId": 10, "Status": 0, "Group": 1},
        {"PieceName": "DVR Kamera Power Kablo", "PieceId": 11, "Status": 0, "Group": 1},
        {"PieceName": "NVR Çoklu Power Kablo", "PieceId": 13, "Status": 0, "Group": 1},
        {"PieceName": "Ahtapot Kablo", "PieceId": 14, "Status": 0, "Group": 1},
        {"PieceName": "Acil Durum Butonu", "PieceId": 15, "Status": 0, "Group": 3},
        {"PieceName": "Monitör", "PieceId": 16, "Status": 0, "Group": 3},
        {"PieceName": "Kimlik Tanıma Birimi", "PieceId": 17, "Status": 0, "Group": 3},
      ],
      toastOptions: {
        theme: "bubble",
        position: "top-center",
        duration : 4000
      }
    }
  },
  computed: {
    gotPieceCount: function() {
      let len = this.equipments.length
      len = this.deviceId.length == 15 ? len + 1 : len
      return len
    }
  },
  methods: {
    insertArizaKaydi() {
      if(!this.arrivalDate) {
        this.$toasted.error('Geçerli bir tarih seçmediniz', this.toastOptions)
        return
      }

      if(!this.regexCheck(this.deviceId)) {
        this.$toasted.error('IMEI numarası doğru girilmedi.', this.toastOptions)
        return
      }

      this.$wait.start('ariza-kayit-inserting')

      this.equipments.forEach((e) => { e.Status = e.Status == 0 ? false : true; })

      let sessionid = localStorage.getItem('utks-sessionid')
      let insertJson = {}
      insertJson.SessionId = sessionid
      insertJson.DeviceId = this.deviceId
      insertJson.DeviceInWarrantyPeriod = this.deviceInWarrantyPeriod
      insertJson.ArrivalDate = moment(this.arrivalDate).format('DD.MM.YYYY')
      insertJson.ArrivalDocumentCode = this.arrivalDocumentCode
      insertJson.IncomingAddress = this.incomingAddress
      insertJson.IncomingSenderName = this.senderName
      insertJson.IncomingPieces = this.equipments
      insertJson.Note = this.arizaNote
      console.log(insertJson)

      axios.post("/api/arizakayit/ekle", insertJson)
      .then(response => {
        if(response.data.HasError == false) {
          this.$router.push('/ariza-kayitlari')
          this.$toasted.success('Arıza kaydı oluşturuldu !', this.toastOptions)      
        }
        else {
          this.$toasted.error('Kayıt oluşturulamadı. Durum mesajı: ' + response.data.ErrorMessage, this.toastOptions)      
        }

        this.$wait.end('ariza-kayit-inserting')
      })
    }, 
    dateFormatter(date) {
      return moment(date).format('DD.MM.YYYY')
    },
    getDeviceInfo(e) {
      this.procStatus = 1
      e.preventDefault()
      let sessionid = localStorage.getItem('utks-sessionid')
      axios
      .post('/api/device/deviceInformation', { "SessionId": sessionid, "DeviceId": this.deviceId })
      .then(response => {
        this.customerTitle = response.data.CustomerTitle
        this.vehicleName = response.data.VehicleName
        this.deviceModel = response.data.DeviceModel
        this.customerAddress = response.data.CustomerAddress
        this.procStatus = 0
      })
      .catch(error => { 
        console.log(error)
        this.procStatus = 0
      })
    },
    regexCheck(imei) {
      const regex = /^\d{15}$/
      let m = regex.exec(imei);
      
      if(m == null || m.length == 0)
        return false
      else
        return true
    },
  },
  mounted() {
    moment.locale('tr')
    //this.arrivalDate = moment().format('L')
  }
}
</script>

<style scoped>
  
  .container {
    max-width: 1280px;
  }
  .transparent-label { color: rgba(0,0,0,0);}
  .light-text { 
    font-weight: 400 !important; 
    -webkit-user-select: none; /* Safari */        
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* IE10+/Edge */
    user-select: none; /* Standard */
  }
  .lh-condensed { line-height: 1.25; } 

  /* The switch - the box around the slider */
.switch {
  position: absolute;
  display: inline-block;
  z-index: 1;
  right: 10px;
  top: 10px;
  width: 40px;
  height: 25px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #1DB954;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #F00;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(14px);
  -ms-transform: translateX(14px);
  transform: translateX(14px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 26px;
}

.slider.round:before {
  border-radius: 50%;
}

input[type="text"].loading {
  background-image: url("~/static/loading.svg");
  background-size: 32px 32px;
  background-position:right center;
  background-repeat: no-repeat;
}

  .vue-wait-class {
    display: block;
    width: 300px;
    text-align: center;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
  }

  .vue-wait-class img {
    width: 160px;
    height: 160px;
    margin: 10px auto 0 auto;
    clear: both;
  }

  .vue-wait-class p {
    width: 100%;
    text-align: center;
    font-size: 20px;
  }
</style>


// WEBPACK FOOTER //
// src/components/ArizaKayitPage.vue